<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"></a><a id="ch01">JUNE 2006</a></h2><a id="ch01">
<p class="noindent1">24/7/365</p>
<p class="noindent">It’s like she can’t breathe anymore, no matter what she does.</p>
<p class="indent">Like everything is closing in on her, crowding her. Threatening her.</p>
<p class="indent">The hearing. The truth coming out. Reliving Durbin’s party in front of a judge and the three bastards themselves, staring her down. Cameras following her around the second she steps outside the courtroom. Exposed as a narc, all of Fieldridge talking about it.</p>
<p class="indent">Talking about her.</p>
</a><p class="indenta"><a id="ch01">For weeks, it’s on the local news. Gossip in the grocery store. Downtown. People point, murmur with heads close </a><a id="page_2">together, those looks on their faces. Randomly coming up to her and asking invasive questions. Strangers, former classmates, leaning into her space, whispering, like they’re her closest confidantes: <span class="txit">So, what did they really do to you?</span></a></p><a id="page_2">
<p class="indenta">Janie’s not cut out for this—she’s a loner. She is underground. It’s like she hasn’t even had time to let all the other stuff sink in—the real, the important. The Janie life-changing stuff. The stuff from the green notebook.</p>
<p class="indent">Going blind. Losing the use of her hands.</p>
<p class="indenta">The pressure is breathtaking.</p>
<p class="indent">She’s suffocating.</p>
<p class="indent">Just wants to run.</p>
<p class="indent">Hide.</p>
<p class="indent">So she can just be.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?693bfa21